'use strict';

/* eslint no-undef: "off" */
/**
 * XPark category floor
 */
define('xparkCategoryFloor',['xparkHomepageApi', 'appStorage', 'GAReport'], function (xparkHomepageApi, appStorage, GAReport) {
  return {
    template: '\n      <section class="xp-category-floor" v-if="categories.length">\n        <h2>Categories</h2>\n\n        <div class="xp-category-grid">\n          <a\n            v-for="item in categories"\n            :key="item.title"\n            class="xp-category-card"\n            :href="item.url"\n            @click="handleGA(item)"\n          >\n            <img :src="item.image" :alt="item.title" />\n            <span v-text="item.title"></span>\n          </a>\n        </div>\n      </section>\n    ',
    data: function data() {
      return {
        loading: false,
        categories: []
      };
    },
    created: function created() {
      var data = appStorage.get("categoryFloor");
      if (data) {
        this.categories = JSON.parse(data);
      }
    },
    mounted: function mounted() {
      this.fetchClassificationFloor();
    },

    methods: {
      fetchClassificationFloor: function fetchClassificationFloor() {
        var _this = this;

        this.loading = true;
        xparkHomepageApi.getClassificationFloor().then(function (data) {
          var list = data && data.categories;

          if (!Array.isArray(list) || !list.length) {
            return;
          }

          _this.categories = list.map(function (item) {
            return {
              title: item.category_name || '',
              image: item.category_image || '',
              url: item.link_url || item.link_rul || 'javascript:void(0);'
            };
          });

          _this.$nextTick(function () {
            appStorage.set("categoryFloor", JSON.stringify(_this.categories));
          });
        }).catch(function () {}).finally(function () {
          return _this.loading = false;
        });
      },
      handleGA: function handleGA(data) {
        console.log(data);
        new GAReport().customerClick({
          eventAction: 'TOP_MENUS_' + data.title,
          eventCategory: 'TOP_MENUS_#VERSION#'
        });
      }
    }
  };
});
